module.exports = __webpack_public_path__ + "static/media/layer-plus.27eddfee.svg";